import { VCombobox } from 'vuetify/lib/components/VCombobox';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCombobox,_vm._b({attrs:{"label":_vm.$t('BCC Email'),"outlined":"","multiple":"","chips":"","clearable":"","deletable-chips":"","hide-details":"auto"},model:{value:(_vm.bccEmail),callback:function ($$v) {_vm.bccEmail=$$v},expression:"bccEmail"}},'v-combobox',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }